import React from "react";
import graphene from "../../../assets/childPage/graph Product Image.png";
import graphene1 from "../../../assets/childPage/graph Hero Image.png";
import graphene2 from "../../../assets/childPage/graph Benefits Image.png";
import ContactUs from "./ContactUs";
import ScrollTop from "../../ScrollTop";

const Graphene = () => {
  return (
    <>
    <ScrollTop />
      <div className="bg-gray-300 pb-5">
        
        <section className="bg-gray-600 flex sm:flex-row justify-center items-center gap-8 lg:gap-24 py-6 px-4">
          <img
            src={graphene}
            alt="graphene"
            loading="lazy"
            className="max-w-48 sm:max-w-sm lg:max-w-lg xl:max-w-4xl 2xl:max-w-6xl  max-h-full object-cover"
          />
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-white text-xl sm:text-5xl lg:text-6xl text-left"
          >
            Graphene <br />
            Coating
          </h4>
        </section>

        <section className="flex flex-col justify-center items-center gap-6 mt-4 sm:mt-16">
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-2xl text-center sm:text-5xl lg:text-6xl"
          >
            What is Graphene Coating?
          </h4>
          <p
            style={{ fontFamily: "Barlow Condensed" }}
            className="text-base text-start sm:text-center px-4 lg:px-16"
          >
            Graphene coatings are considered the newest innovations to emerge in
            the automobile industry. However, Graphene is a carbon-based
            material that is not really new. Graphene comprising one layer of
            carbon atoms, is praised as the sturdiest material known to exist on
            earth. It is 200 times more rigid than steel and lighter than paper.
            Two things account for this strength. Today, Graphene is
            increasingly getting accepted among detailers due to its hardness
            and ‘anti-static properties. Furthermore, it does not allow the dust
            to settle down on the surface coated with it because of its
            anti-static properties.
          </p>
          <img src={graphene1} alt="graphene1" loading="lazy" />
        </section>

        <section className="flex flex-col justify-center- items-center gap-6 mt-4 sm:mt-16 px-4">
          <h4
            style={{ fontFamily: "Ballega" }}
            className="text-2xl text-center sm:text-5xl lg:text-6xl"
          >
            Benefits of Graphene Coating for Cars
          </h4>
          <p
            style={{ fontFamily: "Barlow Condensed" }}
            className="text-base text-start sm:text-center px-4 lg:px-16"
          >
            The advantages of ceramic coating include a deep gloss, easy
            maintenance and cleaning, resistance to stains and scratches,
            protection from UV rays, temperature regulation, interior
            protection, duration, and an included warranty. Ceramic coating is
            transparent and enhances the reflective properties of your car's
            paint.
          </p>
        </section>

        <section
          style={{ fontFamily: "Ballega" }}
          className="text-base lg:flex justify-center items-center mx-4 lg:mx-16 px-4 py-6 mt-4 shadow-[-8px_-8px_20px_0px_rgba(0,_0,_0,_0.25)_inset,8px_8px_20px_0px_rgba(0,_0,_0,_0.25)_inset] rounded-xl"
        >
          <div className="lg:w-1/2">
            <h4
              style={{ fontFamily: "Ballega" }}
              className="text-2xl text-center lg:text-start lg:pl-8 lg:text-3xl"
            >
              Benefits of Paint Protection Film for Cars
            </h4>
            <div
              style={{ fontFamily: "Barlow Condensed" }}
              className="text-base px-4 sm:px-16 py-6"
            >
              <ul className="list-disc list-outside pl-6">
                <li className="mb-2">
                  <span className="font-bold">Superior Durability: </span>
                  Graphene coating provides an ultra-durable layer that protects
                  your car's paint from scratches, chips, and wear, ensuring
                  long-lasting protection.
                </li>
                <li className="mb-2">
                  <span className="font-bold">
                    Enhanced Hydrophobic Properties:{" "}
                  </span>
                  Graphene coating repels water and other liquids more
                  effectively than traditional ceramic coatings, reducing water
                  spots and making cleaning much easier.
                </li>
                <li className="mb-2">
                  <span className="font-bold">Heat Dissipation: </span>
                  Graphene's excellent thermal conductivity helps dissipate heat
                  from the car's surface, minimizing damage caused by prolonged
                  sun exposure.
                </li>
                <li className="mb-2">
                  <span className="font-bold">Anti-Corrosion Protection: </span>
                  The anti-corrosive properties of graphene prevent rust and
                  chemical damage, extending the lifespan of your car's body and
                  paint.
                </li>
                <li className="mb-2">
                  <span className="font-bold">Sleek and Glossy Finish: </span>
                  Graphene coating enhances the depth and shine of your car's
                  paint, providing a rich and glossy finish that elevates its
                  aesthetic appeal.
                </li>
                <li className="mb-2">
                  <span className="font-bold">Eco-Friendly Maintenance: </span>
                  With graphene coating, you can clean your car with less water
                  and fewer chemicals, making maintenance environmentally
                  friendly and hassle-free.
                </li>
                <li className="mb-2">
                  <span className="font-bold">
                    UV and Oxidation Resistance:{" "}
                  </span>
                  Graphene coating protects your car's paint from harmful UV
                  rays and oxidation, preventing fading and maintaining a fresh
                  look for years.
                </li>
              </ul>
            </div>
          </div>
          <img src={graphene2} alt="graphene2" className="w-full lg:w-1/2" loading="lazy" />
        </section>

        <ContactUs />
      </div>
    </>
  );
};

export default Graphene;
